import type { ReactNode } from 'react';

export function EmptyState({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children?: ReactNode;
}) {
  return (
    <div className="empty-state" role="status">
      <span className="empty-state-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Z" />
          <path d="m4 7.5 8 4.5 8-4.5M12 12v9" />
        </svg>
      </span>
      <p className="font-display text-lg font-semibold text-surface-100">{title}</p>
      {description ? (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-surface-400">{description}</p>
      ) : null}
      {children}
    </div>
  );
}
